import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6" }
const _hoisted_2 = { class: "flex items-center justify-between gap-4" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-medium text-gray-900" }, "Ativar notificações neste dispositivo", -1)
const _hoisted_5 = { class: "text-sm text-gray-500 mt-0.5" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3 text-sm text-warning"
}

import { computed, onMounted, ref } from 'vue'
import { useToast } from 'vue-toastification'
import { mdiBellOutline } from '@mdi/js'

import Switch from '@/components/designSystem/Switch/index.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { usePushNotifications } from '@/hooks/usePushNotifications'

import SettingsCard from '../atoms/SettingsCard.vue'
import ComingSoonCard from '../atoms/ComingSoonCard.vue'

const FCM_TOKEN_KEY = '@ME:fcm_token'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsPanel',
  setup(__props) {

const { flags } = useFeatureFlags()
const toast = useToast()
const { permissionStatus, isRegistering, requestPermission, registerAndSubscribe, unsubscribe } =
  usePushNotifications()

const pushEnabled = ref(false)

const pushBlocked = computed(() => permissionStatus.value === 'denied')

const pushStatusText = computed(() => {
  if (pushBlocked.value) return 'Bloqueado pelo navegador'
  return pushEnabled.value ? 'Ativado neste dispositivo' : 'Desativado'
})

onMounted(() => {
  if (!flags.enabledWebPushNotifications) return
  permissionStatus.value = 'Notification' in window ? Notification.permission : 'denied'
  pushEnabled.value = permissionStatus.value === 'granted' && !!localStorage.getItem(FCM_TOKEN_KEY)
})

const togglePush = async (value: boolean) => {
  if (value) {
    const granted = await requestPermission()
    if (!granted) {
      pushEnabled.value = false
      toast.error('Não foi possível ativar as notificações. Verifique as permissões do navegador.')
      return
    }
    await registerAndSubscribe()
    pushEnabled.value = true
    toast.success('Notificações push ativadas!')
  } else {
    await unsubscribe()
    pushEnabled.value = false
    toast.success('Notificações push desativadas.')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(flags).enabledWebPushNotifications)
      ? (_openBlock(), _createBlock(SettingsCard, {
          key: 0,
          title: "Notificações push",
          description: "Receba alertas no navegador mesmo com o Minha Escala fechado."
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("p", _hoisted_5, _toDisplayString(pushStatusText.value), 1)
              ]),
              _createVNode(Switch, {
                "model-value": pushEnabled.value,
                loading: _unref(isRegistering),
                disabled: pushBlocked.value,
                "data-testid": "notifications-push-toggle",
                "onUpdate:modelValue": togglePush
              }, null, 8, ["model-value", "loading", "disabled"])
            ]),
            (pushBlocked.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, " As notificações estão bloqueadas nas configurações do navegador. Libere-as para este site para poder ativá-las. "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(ComingSoonCard, {
          key: 1,
          icon: _unref(mdiBellOutline),
          title: "Notificações push",
          description: "Em breve você poderá ativar alertas no navegador para não perder atualizações.",
          "test-id": "notifications-push-coming-soon"
        }, null, 8, ["icon"]))
  ]))
}
}

})